// src\themes\tolica\elements\footer\FooterList.tsx
"use client"

import Link from "next/link"
import { Heading } from "@/components/ui/Heading"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { useState } from "react"
import { MenuItem } from "@/core/types/menuApi"

type FooterListProps = {
  footerItems: MenuItem[]
}

export default function FooterList({ footerItems }: FooterListProps) {
  const [openItems, setOpenItems] = useState<string[]>([])
  const isOpen = (id: string) => openItems.includes(id)

  return (
    <>
      {/* MOBILE */}
      <div className="sm:hidden">

        <Accordion
          type="multiple"
          value={openItems}
          onValueChange={setOpenItems}
          className="w-full border border-primary-100 overflow-hidden"
        >
          {footerItems.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id.toString()}
              className="border-b border-primary-100 last:border-none"
            >
              <AccordionTrigger className="flex items-center justify-between px-4 py-4 hover:no-underline [&>svg]:hidden">

                <Heading
                  level={4}
                  className="text-primary-900 text-sm"
                >
                  {item.title}
                </Heading>
                <div className="relative size-4 flex items-center justify-center">
                  {/* خط چپ */}
                  <span
                    className={`absolute block h-px w-2 bg-primary-500 rounded-full transition-all duration-300 ease-in-out
      ${isOpen(item.id.toString())
                        ? "-rotate-45 translate-x-[2.5px]"   // حالت باز: ∧
                        : "rotate-45 translate-x-[2.5px]"    // حالت بسته: ∨
                      }
    `}
                  />
                  {/* خط راست */}
                  <span
                    className={`absolute block h-px w-2 bg-primary-500 rounded-full transition-all duration-300 ease-in-out
      ${isOpen(item.id.toString())
                        ? "rotate-45 -translate-x-[2.5px]"   // حالت باز: ∧
                        : "-rotate-45 -translate-x-[2.5px]"  // حالت بسته: ∨
                      }
    `}
                  />
                </div>





              </AccordionTrigger>

              <AccordionContent className="px-4 pb-4">

                <ul>

                  {item.children?.map((child) => (
                    <li key={child.id} className="py-2">

                      <Link
                        href={child.link}
                        className="block text-xs text-primary-900"
                      >
                        {child.title}
                      </Link>

                    </li>
                  ))}

                </ul>

              </AccordionContent>

            </AccordionItem>
          ))}
        </Accordion>

      </div>

      {/* DESKTOP */}
      <div className="hidden sm:grid w-full grid-cols-[repeat(auto-fit,minmax(180px,max-content))] gap-x-10 gap-y-8">

        {footerItems.map((item) => (
          <div key={item.id} className="space-y-4">

            <Heading
              level={4}
              className="text-primary-900 text-sm"
            >
              {item.title}
            </Heading>

            <ul className="space-y-3">

              {item.children?.map((child) => (
                <li key={child.id}>
                  <Link
                    href={child.link}
                    className="text-sm text-primary-900"
                  >
                    {child.title}
                  </Link>
                </li>
              ))}

            </ul>

          </div>
        ))}

      </div>
    </>
  )
}
